import React from 'react'

const Image = ({uri = ""})=> {
    return (
            <img className="rounded-full w-[30px] h-[30px] md:w-[60px] md:h-[60px] border border-gray-100 shadow-sm" src={uri} alt={uri} />
    )
}
export default Image
